function isJwtFormat(token) {
  return token.split('.').length === 3;
}

module.exports = isJwtFormat;
